import type { ErrorMessage } from '@/core/api/error-messages';

export const SOURCE_ERRORS: Record<string, ErrorMessage> = {
  'Source.NotFound': {
    title: 'Fuente no encontrada',
    message: 'La fuente especificada no existe en el sistema.',
    severity: 'error',
  },
  'Source.NameAlreadyExists': {
    title: 'Nombre duplicado',
    message: 'El nombre de la fuente ya se encuentra registrado en el sistema.',
    severity: 'error',
  },
  'Source.UrlAlreadyExists': {
    title: 'URL duplicada',
    message: 'La URL ya se encuentra registrada en el sistema.',
    severity: 'error',
  },
  'Source.Url.Invalid': {
    title: 'URL inválida',
    message: 'La URL debe ser válida y accesible.',
    severity: 'error',
  },
  'Source.UpdateInterval.Invalid': {
    title: 'Intervalo inválido',
    message: 'El intervalo de actualización debe ser de al menos 1 hora.',
    severity: 'error',
  },
  'Source.RegionIds.Empty': {
    title: 'Regiones requeridas',
    message: 'Debe seleccionar al menos una región.',
    severity: 'error',
  },
  'Source.RegionIds.Invalid': {
    title: 'Regiones inválidas',
    message: 'Uno o más IDs de región no son válidos.',
    severity: 'error',
  },
  'Source.AlreadyEnabled': {
    title: 'Fuente ya habilitada',
    message: 'La fuente ya se encuentra habilitada.',
    severity: 'warning',
  },
  'Source.AlreadyDisabled': {
    title: 'Fuente ya deshabilitada',
    message: 'La fuente ya se encuentra deshabilitada.',
    severity: 'warning',
  },
  'Source.AlreadyDeleted': {
    title: 'Fuente ya eliminada',
    message: 'La fuente ya se encuentra eliminada en el sistema.',
    severity: 'error',
  },
  'Source.CannotDeleteEnabled': {
    title: 'Fuente habilitada',
    message: 'La fuente debe estar deshabilitada antes de poder eliminar.',
    severity: 'error',
  },
  'Source.HasActiveDependencies': {
    title: 'Dependencias activas',
    message: 'No se puede eliminar esta fuente debido a dependencias activas.',
    severity: 'error',
  },
  'Source.BaseUrl.Required': {
    title: 'URL base requerida',
    message: 'La URL base es requerida para este tipo de fuente.',
    severity: 'error',
  },
  'Source.Username.Required': {
    title: 'Usuario requerido',
    message: 'El usuario es requerido para este tipo de fuente.',
    severity: 'error',
  },
  'Source.Password.Required': {
    title: 'Contraseña requerida',
    message: 'La contraseña es requerida para este tipo de fuente.',
    severity: 'error',
  },
  'Source.ApiKey.Required': {
    title: 'API Key requerida',
    message: 'El API Key es requerido para este tipo de fuente.',
    severity: 'error',
  },
  'Source.ApiSecret.Required': {
    title: 'API Secret requerido',
    message: 'El API Secret es requerido para este tipo de fuente.',
    severity: 'error',
  },
  'Source.Keywords.Empty': {
    title: 'Palabras clave requeridas',
    message: 'Debe ingresar al menos una palabra clave para Google Trends.',
    severity: 'error',
  },
};
